@if (routes$ | async; as route) {
  <div class="wrapper">
    <header>
      <app-logo routerLink="/landing" />
    </header>
    <div class="subheader">
      <p>"{{ 'SIGN.LBEP' | translate }}"</p>
    </div>
    <div class="centered">
      <main>
        <div class="content">
          <div class="title">
            @switch (route) {
              @case ('in') {
                <p>{{ 'SIGN.ANAP' | translate | uppercase }}</p>
              }
              @case ('up') {
                <p>{{ 'SIGN.RENA' | translate | uppercase }}</p>
              }
              @case ('code') {
                <p>{{ 'SIGN.ICR' | translate | uppercase }}</p>
              }
            }
          </div>
          <div class="forms">
            <router-outlet />
          </div>
          <div class="register">
            @switch (route) {
              @case ('in') {
                <p routerLink="/sign/up">{{ 'SIGN.ANER' | translate }}</p>
              }
              @case ('up') {
                <p routerLink="/sign/in">{{ 'SIGN.YER' | translate }}</p>
              }
              @case ('code') {
                <p routerLink="/sign/in">{{ 'SIGN.VA' | translate }}</p>
              }
            }
          </div>
          <div class="providers">
            <app-sign-providers />
          </div>
        </div>
      </main>
    </div>
    <footer>
      <p>{{ 'SIGN.LARR' | translate }}.</p>
    </footer>
  </div>
}
@if (providers.loading()) {
  <div class="loader">
    <icon name="ph:spiral-fill" size="64"></icon>
    <p>{{ 'SIGN.RG' | translate }}</p>
  </div>
}
